<template>
    <div class="main-div" v-loading="mainLoading">
        <div class="wx-key-div">
            <div class="flex-div" style="font-weight: bold;font-size: 15px;">
                微信支付
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    微信AppId
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="wxAppId"></el-input>
                <el-button class="flex-div-right" size="small" @click="wxAppIdClick">更新</el-button>
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    微信AppSecret
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="wxAppSecret"></el-input>
                <el-button class="flex-div-right" size="small" @click="wxAppSecretClick">更新</el-button>
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    微信商户号
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="wxMchId"></el-input>
                <el-button class="flex-div-right" size="small" @click="wxMchIdClick">更新</el-button>
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    微信商户密钥
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="wxKey"></el-input>
                <el-button class="flex-div-right" size="small" @click="wxKeyClick">更新</el-button>
            </div>
        </div>
        <div class="ali-key-div">
            <div class="flex-div" style="font-weight: bold;font-size: 15px;">
                支付宝
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    支付宝AppId
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="aliAppId"></el-input>
                <el-button class="flex-div-right" size="small" @click="aliAppIdClick">更新</el-button>
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    支付宝私钥
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="aliPrivateKey"></el-input>
                <el-button class="flex-div-right" size="small" @click="aliPrivateKeyClick">更新</el-button>
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    支付宝公钥
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="aliPublicKey"></el-input>
                <el-button class="flex-div-right" size="small" @click="aliPublicKeyClick">更新</el-button>
            </div>
        </div>
        <div class="template-div">
            <div class="flex-div" style="font-weight: bold;font-size: 15px;">
                公众号消息模板
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    充值成功模板
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="gzhRechargeTemplate"></el-input>
                <el-button class="flex-div-right" size="small" @click="gzhRechargeTemplateClick">更新</el-button>
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    报警信息模板
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" disabled v-model="gzhWarningTemplate"></el-input>
                <el-button class="flex-div-right" size="small" @click="gzhWarningTemplateClick">更新</el-button>
            </div>
        </div>
        <div class="rate-div">
            <div class="flex-div" style="font-weight: bold;font-size: 15px;">
                网络支付服务费率
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    微信服务费率
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" v-model.trim="wxRate"></el-input>
                <el-button class="flex-div-right" size="small" @click="wxRateClick">更新</el-button>
            </div>
            <div class="flex-div">
                <div class="flex-div-left">
                    支付宝服务费率
                </div>
                <el-input class="flex-div-middle" size="small" placeholder="未设置" v-model.trim="aliRate"></el-input>
                <el-button class="flex-div-right" size="small" @click="aliRateClick">更新</el-button>
            </div>
        </div>
        <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="50%">
            <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="textarea">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose">取 消</el-button>
                <el-button type="primary" @click="dialogSave">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
  import { checkKeycode,updateKeycode} from '@/api/keycode'
  export default {
    name: "secretKeyConfig",
    data() {
      return {
        customerId:this.$store.getters.customerId,
        wxAppId:"",
        wxAppSecret: "",
        wxKey:"",
        wxMchId:"",
        aliAppId:"",
        aliPrivateKey:"",
        aliPublicKey:"",
        gzhRechargeTemplate: "",
        gzhWarningTemplate: "",
        wxRate: null,
        aliRate: null,
        dialogVisible:false,
        dialogTitle:"",
        textareaKey:"",
        textarea:"",
        mainLoading: false
      }
    },
    mounted() {
      this.checkKey()
    },
    methods: {
      checkKey(){   //查询秘钥状态
        this.mainLoading = true
        checkKeycode(this.customerId).then(response => {
          this.mainLoading = false
          if(response.code === 200){
            let keyCodeStatus=response.infoJson
            this.wxAppId=keyCodeStatus.wxAppId
            this.wxAppSecret=keyCodeStatus.wxAppSecret
            this.wxKey=keyCodeStatus.wxKey
            this.wxMchId=keyCodeStatus.wxMchId
            this.aliAppId=keyCodeStatus.aliAppId
            this.aliPrivateKey=keyCodeStatus.aliPrivateKey
            this.aliPublicKey=keyCodeStatus.aliPublicKey
            this.wxRate=keyCodeStatus.wxRate
            this.aliRate=keyCodeStatus.aliRate
            this.gzhRechargeTemplate=keyCodeStatus.gzhRechargeTemplate
            this.gzhWarningTemplate=keyCodeStatus.gzhWarningTemplate
          }
        }).catch(error => {
          this.mainLoading = false
          this.$message({
            type: 'error',
            message: '秘钥状态查询失败'
          })
        })
        this.dialogVisible=false
        this.textareaKey=""
        this.textarea=""
        this.dialogTitle=""
      },
      /**
       * 更新单个密钥
       * @param key
       * @param value
       */
      updateKey(key,value){
        if (value === null || value === undefined || value === '') {
          this.$confirm('确定要设置为空值?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            updateKeycode(this.customerId,key,value).then(response => {
              if(response.code === 200 && response.infoJson === true){
                this.$message({
                  type: 'success',
                  message: '更新成功'
                })
                this.checkKey()
              }else{
                this.$message({
                  type: 'error',
                  message: '更新失败'
                })
              }
            }).catch(error => {
              this.$message({
                type: 'error',
                message: '更新失败'
              })
            })
          }).catch(() => {})
        } else {
          updateKeycode(this.customerId,key,value).then(response => {
            if(response.code === 200 && response.infoJson === true){
              this.$message({
                type: 'success',
                message: '更新成功'
              })
              this.checkKey()
            }else{
              this.$message({
                type: 'error',
                message: '更新失败'
              })
            }
          }).catch(error => {
            this.$message({
              type: 'error',
              message: '更新失败'
            })
          })
        }
      },
      dialogSave(){ //保存
        this.updateKey(this.textareaKey,this.textarea.trim())
      },
      dialogClose(){
        this.dialogVisible=false
        this.textareaKey=""
        this.textarea=""
        this.dialogTitle=""
      },
      wxAppIdClick(){
        this.dialogTitle="更新微信AppId"
        this.textareaKey="wxAppId"
        this.dialogVisible=true
      },
      wxAppSecretClick(){
        this.dialogTitle="更新微信AppSecret"
        this.textareaKey="wxAppSecret"
        this.dialogVisible=true
      },
      wxKeyClick(){
        this.dialogTitle="更新微信商户密钥"
        this.textareaKey="wxKey"
        this.dialogVisible=true
      },
      wxMchIdClick(){
        this.dialogTitle="更新微信商户号"
        this.textareaKey="wxMchId"
        this.dialogVisible=true
      },
      aliAppIdClick(){
        this.dialogTitle="更新支付宝AppId"
        this.textareaKey="aliAppId"
        this.dialogVisible=true
      },
      aliPrivateKeyClick(){
        this.dialogTitle="更新支付宝私钥"
        this.textareaKey="aliPrivateKey"
        this.dialogVisible=true
      },
      aliPublicKeyClick(){
        this.dialogTitle="更新支付宝公钥"
        this.textareaKey="aliPublicKey"
        this.dialogVisible=true
      },
      gzhRechargeTemplateClick(){
        this.dialogTitle="更新公众号充值成功模板"
        this.textareaKey="gzhRechargeTemplate"
        this.dialogVisible=true
      },
      gzhWarningTemplateClick(){
        this.dialogTitle="更新公众号报警信息模板"
        this.textareaKey="gzhWarningTemplate"
        this.dialogVisible=true
      },
      wxRateClick() {
        if(/^\d{0,3}(\.\d+)?$/.test(this.wxRate)) {
          let rate = parseFloat(this.wxRate)
          if (rate >= 1 || rate < 0) {
            this.$message({
              type: 'error',
              message: '请输入0到1之间的数字'
            })
          } else {
            this.updateKey("wxRate",this.wxRate)
          }
        } else {
          this.$message({
            type: 'error',
            message: '请输入0到1之间的数字'
          })
        }
      },
      aliRateClick() {
        if(/^\d{0,3}(\.\d+)?$/.test(this.aliRate)) {
          let rate = parseFloat(this.aliRate)
          if (rate >= 1 || rate < 0) {
            this.$message({
              type: 'error',
              message: '请输入0到1之间的数字'
            })
          } else {
            this.updateKey("aliRate",this.aliRate)
          }
        } else {
          this.$message({
            type: 'error',
            message: '请输入0到1之间的数字'
          })
        }
      }
    }
  }
</script>

<style scoped>
    .main-div{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        align-items:center;
    }
    .wx-key-div{

    }
    .ali-key-div{

    }
    .template-div{

    }
    .rate-div{

    }
    .flex-div {
        display: flex;
        min-width: 400px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .flex-div-left {
        line-height: 32px;
        width: 130px;
        font-size: 14px;
        min-width: 130px;
    }
    .flex-div-middle {
        margin-right: 10px;
        max-width: 350px;
        width: 300px;
    }
    .flex-div-right {
        width: 80px;
        height: 32px;
    }
</style>